import React from "react";
import { TranslationsContext } from "@teliaee/telia-translate";
import { Notice } from "telia-front-react";
import { contactAddressMatchesInvoiceDeliveryAddress } from "../util/AddressUtil.mjs";
const AddressMismatchNotice = (props) => {
  const { contactInfoEmail, contactInfoAddress, invoiceSettings } = props;
  const { translate } = React.useContext(TranslationsContext);
  if (contactAddressMatchesInvoiceDeliveryAddress(contactInfoEmail, contactInfoAddress, invoiceSettings)) {
    return null;
  }
  return /* @__PURE__ */ React.createElement(Notice, { type: "attention", size: "small", className: "text__margin-double" }, translate("dataconfirm.validationCheck.addressMismatchNotice"));
};
export {
  AddressMismatchNotice as default
};
